import { AuxRadio, AuxNumericStepper, AuxSelect } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import { defaultTimePeriodDisplayValues, lastPeriodDropdownOptions } from "components/time-period/insSettingsTimePeriodHelper";
import { useWidgetCurrentTimePeriod, useWidgetCurrentLastPeriod, useWidgetCurrentLastPeriodStep } from "components/widgets/hooks/use-current-widget";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentStatusSelectedRadioTimePeriod, setCurrentStatusLastPeriodStep, setCurrentStatusLastPeriod, updateDraftWorkspaceDateSettings } from "store/current-dashboard";
import { LastPeriods, TimePeriods } from "store/current-dashboard/types";
const DEFAULT_LAST_PERIOD_STEP = 3;
export const InsLastPeriod = (props) => {
    const isDashboard = props.isWidgetSettings === false;
    const dispatch = useDispatch();
    const draftDateSettings = useSelector((state) => state.currentDashboard?.draftWorkspaceSettings?.dateSettings);
    const workspaceDateSettings = useSelector((state) => state.currentDashboard?.workspaceSettings?.dateSettings);
    const widgetLastPeriod = useWidgetCurrentLastPeriod(props.sectionId, props.widgetIds[0]);
    const widgetLastPeriodStep = useWidgetCurrentLastPeriodStep(props.sectionId, props.widgetIds[0]);
    const widgetSelectedRadio = useWidgetCurrentTimePeriod(props.sectionId, props.widgetIds[0]);
    const selectedRadio = isDashboard
        ? draftDateSettings?.selectedRadio ?? workspaceDateSettings?.selectedRadio ?? defaultTimePeriodDisplayValues.selectedRadio
        : widgetSelectedRadio;
    const lastPeriod = isDashboard
        ? draftDateSettings?.lastPeriod ?? workspaceDateSettings?.lastPeriod ?? defaultTimePeriodDisplayValues.lastPeriod
        : widgetLastPeriod;
    const lastPeriodStepper = isDashboard
        ? draftDateSettings?.lastPeriodStep ?? workspaceDateSettings?.lastPeriodStep ?? defaultTimePeriodDisplayValues.lastPeriodStep
        : widgetLastPeriodStep;
    const isSelected = selectedRadio === TimePeriods.LastSpecifiedPeriod;
    return (React.createElement("div", { className: "insRadioGroupDiv", key: TimePeriods.LastSpecifiedPeriod },
        React.createElement(AuxRadio, { radioGroup: "timePeriod", eventData: TimePeriods.LastSpecifiedPeriod, isChecked: isSelected, onRadioChanged: (event) => {
                const newRadio = event.detail.value.eventData;
                if (isDashboard) {
                    dispatch(updateDraftWorkspaceDateSettings({
                        lastPeriod: lastPeriod ?? LastPeriods.Months,
                        lastPeriodStep: lastPeriodStepper ?? DEFAULT_LAST_PERIOD_STEP,
                        selectedRadio: newRadio
                    }));
                }
                else {
                    dispatch(setCurrentStatusSelectedRadioTimePeriod({ props, selectedRadio: newRadio }));
                }
            } }),
        React.createElement("span", { className: "radioGroupLabel" }, "Last\u00A0\u00A0"),
        React.createElement(AuxNumericStepper, { step: 1, id: "timePeriodStepper", stepperValue: lastPeriodStepper, className: "top-margin", size: AuxButtonSizeEnum.SMALL, isDisabled: !isSelected, onFormValueChanged: (event) => {
                const newStep = event.detail.value;
                if (isDashboard) {
                    dispatch(updateDraftWorkspaceDateSettings({ lastPeriodStep: newStep }));
                }
                else {
                    dispatch(setCurrentStatusLastPeriodStep({ lastPeriodStep: newStep, props }));
                }
            }, minValue: 1 }),
        React.createElement("span", { className: "radioGroupLabel" }, "\u00A0\u00A0"),
        React.createElement(AuxSelect, { onSelectionChanged: (event) => {
                const newLastPeriod = event.detail.value.value;
                if (isDashboard) {
                    dispatch(updateDraftWorkspaceDateSettings({ lastPeriod: newLastPeriod }));
                }
                else {
                    dispatch(setCurrentStatusLastPeriod({ lastPeriod: newLastPeriod, props }));
                }
            }, hasInitialOptionPlaceholder: false, id: "lastPeriodSelect", className: "insRadioSelectWidth", isCompact: false, size: AuxButtonSizeEnum.SMALL, data: [{ values: lastPeriodDropdownOptions[0].values.map((option) => ({ ...option, isSelected: option.value === lastPeriod })) }], isDisabled: !isSelected })));
};
